module.exports = function sharingModeStore(state, emitter) {
  if (!state.sharingMode) {
    state.sharingMode = {
      active: false,
      phase: null,
      currentSceneIndex: null,
    };
  }
  function resetSharingMode() {
    state.sharingMode.active = false;
    state.sharingMode.phase = null;
    state.sharingMode.currentSceneIndex = null;
  }

  emitter.on("share-project", () => {
    const scenes = (state.project && state.project.scenes) || [];
    const totalScenes = scenes.length;
    if (!totalScenes) {
      emitter.emit("share-project-confirmed");
      return;
    }
    const multipleLevels = totalScenes > 1;
    state.sharingMode.active = true;
    state.sharingMode.phase = "intro";
    const firstSceneIndex = 0;
    const currentSceneIndex = multipleLevels
      ? firstSceneIndex
      : scenes.indexOf(state.currentScene);
    state.sharingMode.currentSceneIndex =
      currentSceneIndex >= 0 ? currentSceneIndex : firstSceneIndex;

    if (multipleLevels && state.currentScene !== scenes[firstSceneIndex]) {
      emitter.emit("load-scene", firstSceneIndex);
    }
    emitter.emit("close-menu");
    emitter.emit("render");
  });

  emitter.on("cancel-sharing-mode", () => {
    if (!state.sharingMode.active) {
      return;
    }
    resetSharingMode();
    emitter.emit("render");
  });

  emitter.on("sharing-mode-next", () => {
    if (!state.sharingMode.active) {
      return;
    }
    if (state.sharingMode.phase === "intro") {
      state.sharingMode.phase = "review";
      emitter.emit("render");
      return;
    }
    const totalScenes = state.project && state.project.scenes ? state.project.scenes.length : 0;
    if (!totalScenes) {
      resetSharingMode();
      emitter.emit("render");
      emitter.emit("share-project-confirmed");
      return;
    }
    let currentIndex = state.sharingMode.currentSceneIndex;
    if (currentIndex === null || currentIndex === undefined) {
      currentIndex = state.project.scenes.indexOf(state.currentScene);
      state.sharingMode.currentSceneIndex = currentIndex;
    }
    if (currentIndex >= totalScenes - 1) {
      resetSharingMode();
      emitter.emit("render");
      emitter.emit("share-project-confirmed");
      return;
    }
    const nextIndex = currentIndex + 1;
    state.sharingMode.currentSceneIndex = nextIndex;
    emitter.emit("load-scene", nextIndex);
    emitter.emit("render");
  });

  emitter.on("sharing-mode-back", () => {
    if (!state.sharingMode.active) {
      return;
    }
    if (state.sharingMode.phase === "intro") {
      return;
    }
    const totalScenes = state.project && state.project.scenes ? state.project.scenes.length : 0;
    if (!totalScenes) {
      return;
    }
    let currentIndex = state.sharingMode.currentSceneIndex;
    if (currentIndex === null || currentIndex === undefined) {
      currentIndex = state.project.scenes.indexOf(state.currentScene);
      state.sharingMode.currentSceneIndex = currentIndex;
    }
    if (currentIndex <= 0) {
      return;
    }
    const prevIndex = currentIndex - 1;
    state.sharingMode.currentSceneIndex = prevIndex;
    emitter.emit("load-scene", prevIndex);
    emitter.emit("render");
  });
};


